import { api_updateRecruitmentContractor } from "../../../../api/apiRecruitmentContractor"
import Swal from "sweetalert2"
import { RespRecruitmentContractorDetail, ReqRecruitmentContractorCaseInfo, ReqCaseInfoText } from "../../../../item/ItemRecruitmentContractor"
import { getOnlyDate } from "../../../../item/ItemTools"
import { getUserInfo } from "../../../Login/Auth"


export function toRevise(item, SwalTitle, { setIsLoading, description, comment, caseOwner, caseStatus, caseReserveDate, caseOnBoardDate, caseResignDate, caseInvalidDate }) {
  console.log(item)
  var mRespRecruitmentContractorDetail = new RespRecruitmentContractorDetail({})
  mRespRecruitmentContractorDetail.fromJson(item)
  // mRespRecruitmentContractorDetail.caseStatus = CASE_STATUS_RESIGN
  setCaseProcessDescription({ mRespRecruitmentContractorDetail, description })
  setCaseComment({ mRespRecruitmentContractorDetail, comment })
  if(caseOwner !== undefined){
    mRespRecruitmentContractorDetail.caseOwner = caseOwner
  }
  if(caseStatus !== undefined){
    mRespRecruitmentContractorDetail.caseStatus = caseStatus
  }
  if(caseReserveDate !== undefined){
    mRespRecruitmentContractorDetail.caseInfo.caseReserveDate = caseReserveDate
  }
  if(caseOnBoardDate !== undefined){
    mRespRecruitmentContractorDetail.caseInfo.caseOnBoardDate = caseOnBoardDate
  }
  if(caseResignDate !== undefined){
    mRespRecruitmentContractorDetail.caseInfo.caseResignDate = caseResignDate
  }
  if(caseInvalidDate !== undefined){
    mRespRecruitmentContractorDetail.caseInfo.caseInvalidDate = caseInvalidDate
  }
  mRespRecruitmentContractorDetail.caseInfo = JSON.parse(JSON.stringify(mRespRecruitmentContractorDetail.caseInfo))
  console.log(mRespRecruitmentContractorDetail)
  updateRecruitmentContractor({mRespRecruitmentContractorDetail, SwalTitle, setIsLoading})
}

function setCaseProcessDescription({ mRespRecruitmentContractorDetail, description }) {
  var userInfo = getUserInfo()
  // console.log(userInfo)
  var cp = mRespRecruitmentContractorDetail.caseInfo.caseProcessDescription
  cp.push(new ReqCaseInfoText({ id: userInfo.accountId, name: userInfo.nickName, text: description }))
}

function setCaseComment({ mRespRecruitmentContractorDetail, comment }) {
  if(comment === "")
  return
  var userInfo = getUserInfo()
  // var caseOwner = mRespRecruitmentContractorDetail.caseOwner
  // var caseOwnerName = mRespRecruitmentContractorDetail.caseOwnerName
  var cc = mRespRecruitmentContractorDetail.caseInfo.caseComment
  cc.push(new ReqCaseInfoText({ id: userInfo.accountId, name: userInfo.nickName, text: getOnlyDate() + " " + comment }))
}

function setReqRecruitmentContractorCaseInfo({ item, description, comment }) {
  // var cp = caseProcessDescription
  // cp.push(new ReqCaseInfoText({ id:caseOwner, name: caseOwnerName, text: getOnlyDate() + "未報到" }))
  // var cc = caseComment
  // if (comment !== "")
  //   cc.push(new ReqCaseInfoText({ id:caseOwner, name: caseOwnerName, text: comment }))
  var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({
    // caseCreateDate,
    // caseReserveDate,
    // customerPositionId,
    // // caseContractorName,
    // // caseSexAge,
    // // caseMobile,
    // caseSignAt,
    // caseCompanyName,
    // caseWorkPlace,
    // caseWorkAddress,
    // caseCustomerPosition,
    // caseProcessDescription: cp,
    // caseComment: cc,
    // caseCancelDate,
    // caseOnBoardDate,
    // caseResignDate
  })
  mReqRecruitmentContractorCaseInfo.fromJson(item)
  return mReqRecruitmentContractorCaseInfo
}


function updateRecruitmentContractor({mRespRecruitmentContractorDetail, SwalTitle, setIsLoading}) {
  if(setIsLoading)
  setIsLoading(true)
  api_updateRecruitmentContractor({
    mRespRecruitmentContractorDetail,
    success: (jsonData) => {
      console.log(jsonData)
      if(setIsLoading)
      setIsLoading(false)
      Swal.fire({
        type: 'success',
        title: SwalTitle,
      }).then(() => {
        window.history.go(-1)
      })
    },
    failure: (err) => {
      console.log(err)
      if(setIsLoading)
      setIsLoading(false)
    }
  })
}